import {
  AppBar,
  Grid,
  makeStyles,
  Toolbar,
  Typography
} from '@material-ui/core'
import React, { useState } from 'react'
import ProcuraFicha from './Components/ProcuraFicha'
import FichaComponent from './Components/FichaComponent'
import { Snackbar } from 'elentari'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    marginTop: 0,
    zIndex: 1,
    overflow: 'hidden'
  },
  content: {
    overflow: 'auto',
    position: 'relative',
    flexGrow: 1,
    backgroundColor: theme.palette.grey['200'],
    padding: 24,
    height: 'calc(100% - 56px)',
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 110px)',
      marginTop: 64
    }
  }
}))

const ConsultaFicha = () => {
  const classes = useStyles()
  const [ficha, setFicha] = useState()
  const [message, setMessage] = useState('')
  return (
    <div className={classes.root}>
      <AppBar position="absolute">
        <Toolbar>
          <Typography variant="h6" align="center">
            Sistema de Consulta de Ordem de Carregamento
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ProcuraFicha setFicha={setFicha} setMessage={setMessage} />
          </Grid>
          {ficha && (
            <Grid item xs={12}>
              <FichaComponent data={ficha} />
            </Grid>
          )}
          <Snackbar
            autoHideDuration={6000}
            message={message}
            onClose={() => setMessage('')}
          />
        </Grid>
      </div>
    </div>
  )
}
export default ConsultaFicha
